import { createAxiosInstance } from '@/api/http'
import env from '@/config/env'
import {
  type GenerateQRCodeParams,
  type QRCodeData,
  type VerifyOTPParams,
  type OTPData,
  type CashoutParams
} from '@/types/auth'

const http = createAxiosInstance(
  {
    baseURL: env.apiBaseUrl
  },
  [],
  {
    withBasicAuth: true
  }
)

const generateQRCode = async (params: GenerateQRCodeParams): Promise<QRCodeData> => {
  const { payload } = params
  const url = 'api/v1/session/generate-qr-code'

  const { data } = await http.post(url, payload)
  return data
}

const verifyOTP = async (params: VerifyOTPParams): Promise<OTPData> => {
  const { payload, sessionId } = params
  const url = `api/v1/session/${sessionId}/verify`

  const { data } = await http.post(url, payload)
  return data
}

const cashout = async (params: CashoutParams) => {
  const { sessionId } = params
  const url = `api/v1/session/${sessionId}/cashout`

  const { data } = await http.post(url)
  return data
}

export default { generateQRCode, verifyOTP, cashout }
